// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-page-redirect .flexcard{border:1px solid #ddd}.w-page-redirect--mobile .flexcard{border:0;border-top:1px solid #ddd}", ""]);
// Exports
module.exports = exports;
